import React, { useEffect, useContext } from 'react';

import { DashboardProvider, DashboardContext } from './DashboardContext';
import { NavContext } from '../../../contexts';

import { 
    BlockMenu 
} from './components';

const PageContent = (props) => {
    const { setBreadcrumbRoot } = useContext(NavContext);
    const { state } = useContext(DashboardContext);
    
    useEffect(() => {
        setBreadcrumbRoot("Admin");
    }, []);

    return (
        <BlockMenu />
    );
}

export const DashboardPage = (props) => {

    return (        
        <DashboardProvider>
            <PageContent />
        </DashboardProvider>        
    );
}